import { useSelector } from 'react-redux';
import { selectAppInfo } from 'store/Params/selectors';
import { RootState } from 'store/types';

export const useAppInfo = () => {
  const appInfo = useSelector((state: RootState) => selectAppInfo(state));
  return appInfo;
};
